const actions = {
  // TRANSACTIONS_STATS_REQUEST: 'TRANSACTIONS_STATS_REQUEST',
  // TRANSACTIONS_STATS_ERROR: 'TRANSACTIONS_STATS_ERROR',
  // TRANSACTIONS_STATS_SUCCESS: 'TRANSACTIONS_STATS_SUCCESS',
  OPEN_TRANSACTION: 'OPEN_TRANSACTION',
  CLOSE_TRANSACTION: 'CLOSE_TRANSACTION',
  openTransaction: (payload) => ({
    type: actions.OPEN_TRANSACTION,
    payload
  }),
  closeTransaction: () => ({
    type: actions.CLOSE_TRANSACTION    
  }),
};

export default actions;
